module.exports = __webpack_public_path__ + "img/rs.8d51c4ce.svg";